import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {State} from "../model/state";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class StateService {

  private stateList: State[];

  constructor(private http: HttpClient) {

  }

  public getStateList(): Observable<State[]> {
    return new Observable<State[]>(observer => {
      if (this.stateList && this.stateList.length > 0) {
        observer.next(this.stateList);
        observer.complete();
      } else {
        this.getStates().subscribe({
          next: states => {
            observer.next(states);
            observer.complete();
          }, error: err => {
            throw new Error('Can\'t load states)');
          }
        });
      }
    });
  }

  private getStates(): Observable<State[]> {
    return this.http.get<State[]>(environment.apiUrl + '/search/stateList');
  }
}
